<template>
  <div style="max-width: 480px;">
    <div class="md:text-center space-y-3">
      <BaseText type="display" size="2xs">
        Personalize your Experience
      </BaseText>
      <BaseText type="body" size="md" class="text-neutral-alpha-650">
        Let's start with what brought you here — tell us a bit about why you're using Foreplay and what you're hoping to
        get out of it.
      </BaseText>
    </div>
    <!-- Form -->
    <div class="space-y-9 md:text-center mt-9 md:mt-16 pb-16 md:pb-0">
      <div v-for="question in SURVEY_QUESTIONS" :key="question.title" class="space-y-4">
        <BaseText type="label" class="text-white">
          {{ question.title }}
        </BaseText>
        <!-- Updated container with smooth layout transitions -->
        <div class="flex flex-wrap md:justify-center items-center gap-3">
          <button v-for="option in question.options" :key="option.key" class="survey-button"
          :class="[surveyForm[question.key] === option.key
            ? 'text-white border-transparent selected'
            : 'text-neutral-alpha-650 border-neutral-alpha-100'
          ]"
          :style="{ backgroundColor: surveyForm[question.key] === option.key ? 'rgba(0, 107, 255, 0.40)' : 'transparent' }"
          @click="setSurveyAnswer(question.key, option.key)">
            <Transition name="fade">
              <CheckmarkIcon v-if="surveyForm[question.key] === option.key" class="w-5 h-5 text-white selected-icon" />
            </Transition>
            <BaseText type="label" class="px-1 survey-button-answer">
              {{ option.title }}
            </BaseText>
          </button>
        </div>
      </div>
      <!-- Submit -->
      <button class="submit-button w-full mt-4 p-2 h-10 flex items-center justify-center transition duration-200"
      :class="isSurveyComplete ? 'bg-white bg-opacity-100 hover:bg-opacity-90' : 'disabled'"
      :disabled="!isSurveyComplete" @click="submitSurvey">
        <BaseLoadingSpinnerCircle v-if="loadingSurveySubmit" :duration="1" />
        <BaseText v-else type="heading" size="sm">
          Next
        </BaseText>
      </button>
    </div>
  </div>
</template>

<script>
import CheckmarkIcon from '../../globals/Icons/CheckmarkIcon.vue'

export default {
  name: 'PersonalizeAuthSection',
  components: {
    CheckmarkIcon
  },
  data () {
    const WORK_OPTIONS = [
      {
        title: 'Agency',
        key: 'agency'
      }, {
        title: 'Brand',
        key: 'brand'
      }, {
        title: 'App / Game',
        key: 'app_or_game'
      },
      {
        title: 'Software',
        key: 'software'
      },
      {
        title: 'Freelancer',
        key: 'freelancer'
      },
      {
        title: 'Other',
        key: 'other'
      }
    ]

    const REFERRER_OPTIONS = [
      {
        title: 'X / Twitter',
        key: 'x_twitter'
      },
      {
        title: 'Linkedin',
        key: 'linkedin'
      },
      {
        title: 'Instagram',
        key: 'instagram'
      },
      {
        title: 'TikTok',
        key: 'tiktok'
      },
      {
        title: 'Google Search',
        key: 'google_search'
      },
      {
        title: 'YouTube',
        key: 'youtube'
      },
      {
        title: 'Newsletter',
        key: 'newsletter'
      },
      {
        title: 'Podcast',
        key: 'podcast'
      },
      {
        title: 'Word of mouth',
        key: 'word_of_mouth'
      },
      {
        title: 'From a friend / colleague',
        key: 'friend_or_colleague'
      },
      {
        title: 'From a client',
        key: 'from_a_client'
      },
      {
        title: 'Ad I saw',
        key: 'ad_i_saw'
      },
      {
        title: 'Other',
        key: 'other'
      }
    ]

    const SURVEY_QUESTIONS = [{
      title: 'What best describes your work? *',
      key: 'work',
      options: WORK_OPTIONS
    },
    {
      title: 'Where did you hear about us? *',
      key: 'referrer',
      options: REFERRER_OPTIONS
    }
    ]
    return {
      SURVEY_QUESTIONS,
      loadingSurveySubmit: false,
      surveyForm: {
        work: null,
        referrer: null
      }
    }
  },
  computed: {
    isSurveyComplete () {
      return this.surveyForm.work && this.surveyForm.referrer
    }
  },
  methods: {
    setSurveyAnswer (key, value) {
      console.log('setSurveyAnswer', key, value)
      this.surveyForm[key] = value
    },
    submitSurvey () {
      this.$emit('next', { step: 'personalize', data: this.surveyForm })
    }
  }
}
</script>

<style scoped>
.submit-button {
  background-color: #1F69FF;
  color: white;
  border-radius: 10px;
  box-shadow: none;
  transition: background-color 150ms ease-in-out, color 150ms ease-in-out, box-shadow 150ms ease-in-out;
}
.submit-button.disabled, .submit-button.disabled:hover {
  background-color: transparent;
  color: rgba(255, 255, 255, 0.32);
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.1);
  cursor: default;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 150ms ease-in-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: scale(0.8);
}

.survey-button {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border-width: 1px;
  border-style: solid;
  border-radius: 8px;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  transition-property: background-color, color, border-color, transform, width, padding;
}

.survey-button .selected-icon {
  position: absolute;
  left: 8px;
  transition: all 0.15s ease-in-out;
}

.survey-button.selected .survey-button-answer {
  padding-left: 24px;
  transition: padding-left 0.15s ease-in-out;
}

.survey-button:not(.selected) .survey-button-answer {
  padding-left: 4px;
  transition: padding-left 0.15s ease-in-out;
}
</style>
